export const environment = {
    production: true,
    apiUrl: 'https://api.suprememotors.jp/api/v1',
    websiteURL: 'https://suprememotors.jp'
};

console.log('Staging environment loaded:', environment);
